import * as Ariakit from '@ariakit/react'
import styled from 'styled-components'

import { Button, TypeStyle, atXs } from '@syconium/little-miss-figgy'

import { NextModalStyles } from '../../../../../../../components/modals/NextModal'
import { fadeUpAndIn } from '../../../../../../styles/shared'
import { fadeDownAndIn } from '../DesktopFilterBar/DesktopFilterNav/styles'

export function deriveModalStyles(): NextModalStyles {
  return {
    content: {
      backgroundColor: 'white',
      borderRadius: 0,
      borderWidth: 0,
      bottom: 0,
      left: 0,
      padding: 0,
      right: 0,
      top: 0,
    },
    overlay: {
      background: 'none',
    },
  }
}

export const Body = styled.div`
  overflow: auto;
  position: relative;
  max-height: 100dvh;
`

export const FilterBody = styled.div`
  min-height: 100dvh;
  padding: 0 16px 0 16px;
  box-sizing: border-box;
  padding-bottom: 100px;
`

export const TopBar = styled.div`
  background: white;
  border-bottom: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  left: 0;
  position: sticky;
  right: 0;
  top: 0;
  z-index: ${o => o.theme.zIndex.foregroundContent};
`

export const TopActions = styled.div`
  display: flex;
  justify-content: space-between;

  ${atXs} {
    height: 20px;
  }
`

export const Headline = styled(TypeStyle.HeadlineExtraExtraSmall)`
  padding: 24px 0;
  text-transform: uppercase;

  ${atXs} {
    padding: 0;
  }
`

// This wrapper exists because position:sticky + display:flex on the same element was buggy in Mobile Safari (April 2020)
export const ActionsWrap = styled.div`
  bottom: 0;
  left: 0;
  width: 100%;
  position: fixed;
`

export const Actions = styled.div`
  background: white;
  border-top: 2px solid ${o => o.theme.color.deprecated.stoneLight};
  display: flex;
  justify-content: center;
  padding: 8px 15px;
`

const ActionButton = styled(Button)`
  ${TypeStyle.css.eyebrow}
  flex: 1;
  padding: 13px 13px;

  ${atXs} {
    height: 15px;
    font-size: 6px;
  }
`

export const ResetButton = styled(ActionButton)`
  border: 2px solid ${o => o.theme.color.deprecated.stoneDark};
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  flex-grow: 1;
  margin-inline-end: 4px;
`

export const ApplyButton = styled(ActionButton)`
  border: 2px solid ${o => o.theme.color.deprecated.obsidian};
  flex-grow: 2;
  margin-inline-start: 4px;
`

export const HiddenCrawlableFilterModalContent = styled.div`
  display: none;
`

export const CloseWrap = styled.button`
  padding-top: 24px;
  padding-bottom: 24px;
  padding-inline-start: 48px;
  padding-inline-end: 0;

  ${atXs} {
    padding-top: 0;
  }

  svg {
    height: 14px;
    width: 14px;
  }
`

export const FilterInputWrap = styled.div<{
  isExpanded?: boolean
}>`
  animation: ${fadeDownAndIn} 0.8s;
`

export const StyledAriakitDialog = styled(Ariakit.Dialog)`
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${o => o.theme.color.fill.background};
  color: ${o => o.theme.color.text.primary.on.background};
  z-index: ${o => o.theme.zIndex.modals};
  width: 100%;
  max-height: 100dvh;
  overflow: none;
  animation: ${fadeUpAndIn} 0.3s ease forwards;
`
